import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model8InitialModel: ModelData = {
  name: 'Template 8 - Dual Door System',
  modelId: 'model8',
  type: 'DOOR',
  description: '8-variant door with symmetrical panels and dual door opening',
  width: 4500,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 4500,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_center_frame_profile',
      type: 'PROFILE',
      width: 1900,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1300, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 4100, y: 2440, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 4440, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_top_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 320,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_glass_panel_1',
      type: 'GLASS',
      width: 900,
      height: 2120,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: 380, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 900 - (frameThickness + 40), y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: -glassHingeWidth / 3, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 0, y: 2120 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 900 - glassLockWidth * 1.5, y: 2120 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'center_glass_panel',
      type: 'GLASS',
      width: 1900,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1300, y: frameThickness, z: 0 },
    },
    {
      positionId: 'right_door_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 2120,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 3200, y: 380, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: frameThickness, y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 900 - glassHingeWidth / 2, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 900 - glassHingeWidth, y: 2120 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: glassLockWidth, y: 2120 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'right_door_top_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 320,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 3200, y: frameThickness, z: 0 },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 4100, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'single_door',
    totalDoorWidth: 1800,
    individualDoorWidth: [900, 900],
    totalHandles: 2,
    openingDirection: 'left_opening, right_opening',
    hingePosition: 'left_side, right_side',
  },
}
